module.exports = __webpack_public_path__ + "media/images/common/ico-ramen-recommend-2a4c4c9095cb328a0c694f0ca137bc39.svg";